import { useTranslation } from 'react-i18next';
import { LegalPageLayout, LegalSection } from './LegalPageLayout';

const TEXT_SECTIONS = [
  'controller',
  'subProcessors',
  'retention',
  'rights',
  'transfers',
  'cookies',
  'contact',
] as const;

export function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <LegalPageLayout titleKey="legal.privacyTitle">
      <p>{t('privacy.intro')}</p>

      <LegalSection titleKey="privacy.dataCollectedTitle">
        <ul className="mt-1 list-disc space-y-2 pl-6 text-muted-foreground">
          <li>{t('privacy.dataIdentity')}</li>
          <li>{t('privacy.dataAudio')}</li>
          <li>{t('privacy.dataUsage')}</li>
        </ul>
      </LegalSection>

      {TEXT_SECTIONS.map((key) => (
        <LegalSection key={key} titleKey={`privacy.${key}Title`}>
          <p className="mt-1 text-muted-foreground">{t(`privacy.${key}Text`)}</p>
        </LegalSection>
      ))}
    </LegalPageLayout>
  );
}
